<template>

  <tr @click="onClickLine" :class="minTable ? '' : 'pointer'">
    <td>
      <v-icon v-if="item['client_reports_exists'] && !minTable" :class="billOpened ? 'rotate' : ''"
        >mdi-menu-right-outline</v-icon
      >
      {{ $formatDate(item.start_date) + ' - ' + $formatDate(item.end_date) }}
    </td>
    <td>{{ showSelectedWeeks({ start: item.start_date, end: item.end_date }) }}</td>
    <td>{{ $formatDate(item['created_at']) }}</td>
    <td>
      <div class="buttons" v-if="userType !== 'subscriber'">
        <div v-if="item.status !== 'new'" class="my-auto">
          <IconTimeControlViewed v-if="item.status !== 'new' && item.status !== 'done'"/>
          <IconTimeControlFullSendCheck v-if="item.status === 'done'"/>
        </div>
        <v-btn
          v-if="minTable && item['client_reports_exists']"
          color="#2F80ED"
          depressed text
          @click="openBillsModal(item.id)"
        >
          <v-icon>mdi-email-mark-as-unread</v-icon>
        </v-btn>
        <ButtonShow :openModal="onOpenReport" />
        <DeleteModal
          v-if="
            userType === 'superadmin' ||
            ($userCheckAccess({
              abilities: 'delete_period_reports',
            }) &&
              !item.is_sent_to_client)
          "
          ref="deleteModal"
          :text="
            localStorage.translations.pages.projects.reports_dialogs.delete_report +
            ' ' +
            $formatDate(item.start_date) +
            ' - ' +
            $formatDate(item.end_date)
          "
          :methodDelete="onDeleteItem"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import ButtonShow from 'components/ButtonShow'
import DeleteModal from 'components/DeleteModal'

import { mapActions, mapGetters } from 'vuex'
import IconTimeControlViewed from "../../icons/timeControl/IconTimeControlViewed.vue";
import IconTimeControlFullSendCheck from "../../icons/timeControl/IconTimeControlFullSendCheck.vue";

export default {
  name: 'StatisticProjectReportsTableItem',
  props: {
    item: [Array, Object],
    function_dataList: Function,
    clickLine: {},
    billOpened: Boolean,
    onBillOpen: {}
  },
  components: {
    IconTimeControlFullSendCheck,
    IconTimeControlViewed,
    DeleteModal,
    ButtonShow,
  },
  data: () => ({
    files: null,
    fileUploadStatus: false,
    fileUrl: null,
    dialog: false,
  }),
  computed: {
    ...mapGetters(['apiDomain']),
    ...mapGetters('user', ['userType']),
    ...mapGetters('workClientProject', ['workClientProjectStatistic']),
    minTable() {
      return this.$vuetify.breakpoint.lgAndDown
    },
    tableHead() {
      return [
        // {
        //     text: '№',
        // },
        {
          text: this.localStorage.translations.pages.projects.reports_table.period,
          sort: {
            name: 'start_date',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'start_date'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {
          text: this.localStorage.translations.pages.projects.reports_table.week_number,
        },
        {
          text: this.localStorage.translations.pages.projects.reports_table.date_create,
          sort: {
            name: 'created_at',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'created_at'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        // {
        //     text: this.localStorage.translations.pages.projects.reports_table.preliminary,
        // },
        // {
        //     text: this.localStorage.translations.pages.projects.reports_table.modified,
        // },
        // {
        //     text: this.localStorage.translations.pages.projects.reports_table.signed,
        // },
        { text: '' },
      ]
    },
  },
  watch: {
    'item.sign_photo'() {
      if (
        item.sign_photo.substring(item.sign_photo.lastIndexOf('.') + 1, item.sign_photo.length) ===
        'pdf'
      ) {
        if (this.$refs.imageModal && this.$refs.imageModal.dialog) {
          this.$refs.imageModal.closeModal()
        }
      } else {
        if (this.$refs.pdfModal && this.$refs.pdfModal.dialog) {
          this.$refs.pdfModal.closeModal()
        }
      }
    },
  },
  methods: {
    ...mapActions('workClientProjectsPeriodReport', [
      'onWorkClientProjectsPeriodReportDelete',
      'onWorkClientProjectsPeriodReportSign',
      'onWorkClientProjectsPeriodReportUnsign',
      'onWorkClientProjectsPeriodReportShow',
    ]),
    selectedDates({ start, end }) {
      let obj = {}
      obj.dates = this.$getDates(start, end)
      obj.weeks = []
      for (let date of obj.dates) {
        if (!obj.weeks.find((i) => i === date.getWeek())) obj.weeks.push(date.getWeek())
      }
      return obj
    },
    showSelectedWeeks({ start, end }) {
      let string = ''
      let weeksList = this.selectedDates({ start, end }).weeks
      if (weeksList) {
        for (let week in weeksList) {
          if (week == 0) {
            string = string + weeksList[week]
          } else {
            string = string + ', ' + weeksList[week]
          }
        }
      }
      return string
    },
    onDeleteItem() {
      this.onWorkClientProjectsPeriodReportDelete(this.item.id)
        .then(() => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
              IsError: false,
            },
            { root: true },
          )
          this.$refs.deleteModal.closeModal()
          this.function_dataList()
        })
        .catch((err) => {
          console.log(err)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
    async onButtonFileUpload(data) {
      this.files = data.files
      await this.submitFile()
      if (this.item.is_signed) {
        await this.onWorkClientProjectsPeriodReportUnsign({ id: this.item.id })
      }
      this.onSignReport()
    },
    onSignReport() {
      let dataSend = {
        sign_photo: this.fileUrl,
      }
      this.onWorkClientProjectsPeriodReportSign({ id: this.item.id, data: dataSend })
        .then(() => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications[
                  'izmeneniya-uspeshno-sohraneny'
                ],
              IsError: false,
            },
            { root: true },
          )
          this.files = null
          this.function_dataList()
        })
        .catch((err) => {
          console.log(err)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
    async submitFile() {
      if (this.files) {
        let formData = new FormData()
        formData.append('file', this.files[0])
        if (this.item.sign_photo) {
          this.$store.dispatch('deleteFile', {
            url: this.item.sign_photo,
          })
        }
        await this.$store
          .dispatch('uploadFile', {
            data: formData,
          })
          .then((response) => {
            this.fileUrl = response.data.url
          })
          .catch()
      }
    },
    onOpenReport() {
      this.$router.push({
        name: 'timeControlShowReportsView',
        params: { report_id: this.item.id },
      })
    },
    onOpenInvoice() {
      this.$router.push({
        name: 'timeControlShowReportsViewCheck',
        params: { report_id: this.item.id },
      })
    },
    onClickLine() {
      if (this.item['client_reports_exists'] && this.clickLine && !this.minTable)
        this.clickLine(this.item.id)
    },
    openBillsModal(id) {
      if (this.onBillOpen) this.onBillOpen(id)
    },
  },
}
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

:deep() .icon {
  display: flex;
  gap: 14px;
}

.v-btn {
  padding: 0 !important;
  min-width: 10px !important;
  height: 100% !important;
  
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    background: #277faf;
    width: 45px !important;
    height: 45px !important;
    border-radius: 50%;
    color: #ffffff !important;
    
    &:hover {
      opacity: 0.9;
    }
  }
}

.modal {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 30px 30px rgba(39, 127, 175, 0.2);
  text-align: start;
  padding: 50px 40px;
  position: relative;
  display: grid;
  row-gap: 40px;
}

.rotate {
  transform: rotate(90deg);
}
</style>
